










































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, State, Action } from 'vuex-class';
import DataPanel from '@/components/DataPanel/DataPanel.vue';
import Icon from './Icon.vue';


@Component({
	components: {
		DataPanel,
		Icon,
	}
})
export default class TypeaheadList extends Vue {
	@State private activeIdx!: number;
	@State private storeInputText!: string;
	@State private list!: any;
	@State private dataPanelSide!: string;
	@State private launcherState!: string;
	@State private rows!: string;
	@State private ifOnboarding!: boolean;
	@State private obAllowedOptions: string[];
	@State private previewState!: any;

	@Getter private displayList!: any;
	@Action private updateActiveIdx!: any;
	@Action private handleInput!: any;

	@Watch('activeIdx')
	private updateActiveIdxWatcher() {
		const activeItem = window.document.getElementById(`item_${this.activeIdx}`);
		if (activeItem != null) {
			(activeItem as any).scrollIntoViewIfNeeded(false);
		}
	}

	private maxItemName(itemName: string) {
		const MAX_LENGTH = (this.dataPanelSide === 'left' ||
							this.dataPanelSide === 'right') ? 30 : 60;
		if (itemName === null) { return ' '; }
		if (itemName.length > MAX_LENGTH) {
			return itemName.substr(0, MAX_LENGTH) + '...';
		}
		return itemName;
	}

	private mouseOver(idx: number) {
		this.updateActiveIdx(idx);
	}

	private handleClick() {
		this.handleInput();
	}

	private get mode() {
		if (this.displayList.length) {
			return this.displayList[this.activeIdx].actionType;   
		} else {
			if (this.previewState && this.previewState.actionType) {
				return this.previewState.actionType;
			} else {
				return null;
			}
		}
	}

	private get tryString() {
		if (this.launcherState === 'INPUT') {
			return 'Please give ally an input ☝️';
		} else if (this.list.length > 0) {
			let str = `🔭 Try "${this.list[0].name}"`;
			for (let i = 1; i < this.list.length; i++) {
				if (i > 2) {
					break;
				}
				str += `, "${this.list[i].name}"`;
			}
			return str;
		} else {
			if (this.launcherState === 'INIT') {
				return 'Loading new options...';
			} else {
				return 'Nothing to show here!'; // PARAM state
			}
		}
	}

	private checkIfItemInOnboarding(itemName: string) {
		if (!!this.obAllowedOptions) {
			for (const name of this.obAllowedOptions) {
				if (itemName.includes(name)) {
					return true;
				}
			}
		}
		return false;
	}
}
